import { useEffect, useState } from 'react';
import { SelectZui } from 'src/components/zui';
import { SelectItem } from 'src/@/components/ui/select';
import { Button } from 'src/@/components/ui/button';
import {
    Popover,
    PopoverContent,
    PopoverTrigger,
} from 'src/@/components/ui/popover';
import Iconify from 'src/components/Iconify';
import getActionListaUsuariosByClienteId from 'src/actions/usuarios/getActionListaUsuariosByClienteId';
import { ButtonLoading } from 'src/@/components/use/ButtonLoading';
import { useSnackbar } from 'notistack';
import v2_actionEditarLead from 'src/actions/v2/crm/v2_actionEditarLead';
import { RowInput } from 'src/components/forms/RowInput';
import { Switch } from 'src/@/components/ui/switch';

// ----------------------------------------------------------------------

export default function DrawerTransferirLead({ user, lead, onCallback }) {
    const [lista, setLista] = useState([]);
    const [selectedUser, setSelectedUser] = useState(null);
    const [transferirConversa, setTransferirConversa] = useState(true);
    const [loading, setLoading] = useState(false);
    const { enqueueSnackbar } = useSnackbar();

    async function buscarUsuarios() {
        try {
            const response = await getActionListaUsuariosByClienteId(user.clienteId);
            setLista(response.data.usuarios);
        } catch (error) {
            console.log('error', error);
        }
    }

    async function editarLead() {
        try {
            let data = {
                action: "transferir_usuario",
                scope: {
                    usuario_id: selectedUser,
                },
                ignoreTransferChat: !transferirConversa,
            };
            setLoading(true);
            await v2_actionEditarLead(lead._id, data, user.id);
            onCallback();
            setLoading(false);
            enqueueSnackbar('Negócio transferido com sucesso', { variant: 'success', autoHideDuration: 3000, anchorOrigin: { vertical: 'bottom', horizontal: 'left' } });
        } catch (error) {
            setLoading(false);
            console.log('error', error);
            enqueueSnackbar('Erro ao transferir negócio', { variant: 'error', autoHideDuration: 3000, anchorOrigin: { vertical: 'bottom', horizontal: 'left' } });
        }
    }

    useEffect(() => {
        buscarUsuarios();
        return () => {
            setLista([]);
            setSelectedUser(null);
        };
    }, []);

    return (
        <Popover>
            <PopoverTrigger asChild>
                <Button
                    variant="outline"
                    size="icon"
                    className="h-8 w-8"
                    title="Transferir negócio"
                    aria-label="Transferir negócio"
                >
                    <Iconify icon="mingcute:transfer-line" width={16} />
                </Button>
            </PopoverTrigger>
            <PopoverContent className="w-80 z-[9999] rounded-xl dark:bg-[#222529] dark:border-[#383838]">
                <div className="flex items-center gap-2.5 mb-3">
                    <div className="w-8 h-8 rounded-lg bg-violet-50 dark:bg-violet-500/10 flex items-center justify-center shrink-0">
                        <Iconify icon="mingcute:transfer-line" width={16} className="text-violet-600 dark:text-violet-400" />
                    </div>
                    <p className="text-sm font-semibold text-gray-900 dark:text-gray-100">Transferir negócio</p>
                </div>
                {!lead.closed ? (
                    <div className="flex flex-col gap-4">
                        <RowInput
                            label={'Selecione o usuário'}
                            input={
                                <SelectZui
                                    value={selectedUser}
                                    list={lista}
                                    fullWidth
                                    onChange={event => {
                                        setSelectedUser(event);
                                    }}
                                    itemSelect={(item) => (
                                        <SelectItem key={item._id} value={item._id}>
                                            {item.nomeFantasia}
                                        </SelectItem>
                                    )}
                                />
                            }
                        />
                        {lead?.whatsapp_chat_id && (
                            <div className="flex items-center gap-2">
                                <Switch
                                    id="transferirConversa"
                                    checked={transferirConversa}
                                    onCheckedChange={setTransferirConversa}
                                />
                                <label htmlFor="transferirConversa" className="text-xs font-medium text-gray-700 dark:text-gray-300">
                                    Transferir também a conversa vinculada
                                </label>
                            </div>
                        )}
                        <ButtonLoading
                            loading={loading}
                            onClick={editarLead}
                            disabled={!selectedUser}
                            className={`w-full ${!selectedUser ? 'bg-slate-300 dark:bg-slate-600' : 'bg-[#7C3AED] hover:bg-[#6d28d9]'}`}
                        >
                            {loading ? 'Transferindo...' : (!selectedUser ? 'Selecione um usuário' : 'Transferir')}
                        </ButtonLoading>
                    </div>
                ) : (
                    <p className="text-[13px] text-gray-600 dark:text-[#ABABAD]">
                        <span className="font-bold">Não é possível</span> transferir um lead finalizado. Reabra o lead para transferir.
                    </p>
                )}
            </PopoverContent>
        </Popover>
    );
}
